import axios from 'axios';
import React, { useContext, useEffect, useRef, useState } from 'react'
import NotificationContext from './toast/NotificationContext';
import { useInView } from 'react-intersection-observer';
import { constants } from '../helpers/constants';

const Contact = ({setActiveContact, deviceMobile}) => {

    const userContact={
        name:'',
        email: '',
        phone:'',
        message: ''
      }
    
      const [infoUser, setInfoUser] = useState(userContact);

      const {showNotification} = useContext(NotificationContext);

      const handleInfoUser = (e) => {
        e.preventDefault();
        setInfoUser({...infoUser, [e.target.name]: e.target.value })
      }

    const sendMailContact = async() => {
        if(infoUser.name ==="" || infoUser.email ==="" || infoUser.phone ==="" || infoUser.message ==="" ) return showNotification('failed', 'Todos los campos deben ser diligenciados.')
        const URL = constants.backend_for_contact + 'mail/send-contact-info';
        await axios.post(URL, {infoUser, portfolio: true}, {headers: {'Content-Type': 'application/json'}, withCredentials: true})
        .then(({data})=> {
            showNotification('success', 'Datos enviados correctamente.')
            setInfoUser(userContact)          
        })
        .catch((err) => {
            console.log(err)
            showNotification('failed', 'Error al enviar los datos.')
        })
    }


    const [divContact, inViewContact] = useInView({ threshold: 0.5});

    useEffect(() => {
        if (inViewContact) {
            setActiveContact(true); // Activa el estado del navbar
        } else {
            setActiveContact(false); // Desactiva el estado cuando ya no está visible
        }
    }, [inViewContact, setActiveContact]);
    
  return (
      <section ref={divContact} className="page-section" id="contact">
          <div className="container px-4 px-lg-5">
              <div className="row gx-4 gx-lg-5 justify-content-center">
                  <div className="col-lg-8 col-xl-6 text-center">
                      <h2 className="mt-0">Contáctame!</h2>
                      <hr className="divider" />
                      <p className="text-muted mb-5">¿Listo para llevar tu proyecto en línea al siguiente nivel? Envíame un mensaje y me pondré en contacto contigo lo antes posible. También puedes escribirme directamente a <strong>contacto@rafaelgutierrez.dev</strong>.</p>
                  </div>
              </div>
              <div className="row gx-4 gx-lg-5 justify-content-center mb-5">
                  <div className="col-lg-6">
                    
                      <form netlify id="contactForm" data-sb-form-api-token="API_TOKEN">
                          {/* Name input*/}
                          <div className="form-floating mb-3">
                              <input
                              className="form-control"
                                id="name" name='name' type="text" required placeholder="Enter your name..." data-sb-validations="required" onChange={(e) =>handleInfoUser(e)}
                                value= {infoUser.name} />
                              <label htmlFor="name">Full name</label>
                              <div className="invalid-feedback" data-sb-feedback="name:required">A name is required.</div>
                          </div>
                          {/* Email address input*/}
                          <div className="form-floating mb-3">
                              <input onChange={(e) =>handleInfoUser(e)}
                                required value= {infoUser.email} className="form-control" id="email" name='email' type="email" placeholder="name@example.com" data-sb-validations="required,email" />
                              <label htmlFor="email">Email address</label>
                              <div className="invalid-feedback" data-sb-feedback="email:required">An email is required.</div>
                              <div className="invalid-feedback" data-sb-feedback="email:email">Email is not valid.</div>
                          </div>
                          {/* Phone number input*/}
                          <div className="form-floating mb-3">
                              <input onChange={(e) =>handleInfoUser(e)}
                                value= {infoUser.phone} className="form-control" id="phone" name='phone' type="number" placeholder="(123) 456-7890" required data-sb-validations="required" />
                              <label htmlFor="phone">Phone number</label>
                              <div className="invalid-feedback" data-sb-feedback="phone:required">A phone number is required.</div>
                          </div>
                          {/* Message input*/}
                          <div className="form-floating mb-3">
                              <textarea onChange={(e) =>handleInfoUser(e)}
                                value= {infoUser.message} className="form-control" id="message" name='message' type="text" placeholder="Enter your message here..." style={{ height: '10rem' }} data-sb-validations="required" defaultValue={""} />
                              <label htmlFor="message">Message</label>
                              <div className="invalid-feedback" data-sb-feedback="message:required">A message is required.</div>
                          </div>
                          
                          
                          <div className="d-grid"><button className="btn btn-primary btn-general " id="submitButton" type="button" onClick={sendMailContact}>Send</button></div>
                      </form>
                  </div>
              </div>
              
          </div>
      </section>

  )
}

export default Contact